import React from 'react'

type FileIconLargeProps = {
  color: string
}

// Temporary solution until we implement IE compatible scaling for assets
export default function ({ color = '#384A51' }: FileIconLargeProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6142 7.23329C16.605 7.20663 16.5975 7.18079 16.5867 7.15496C16.5459 7.06663 16.495 6.98246 16.4234 6.91079L11.4234 1.91079C11.3517 1.83913 11.2675 1.78829 11.1792 1.74746C11.1542 1.73579 11.1275 1.72913 11.1009 1.71996C11.0309 1.69663 10.9592 1.68163 10.885 1.67746C10.8667 1.67579 10.8509 1.66663 10.8334 1.66663H5.00004C4.08087 1.66663 3.33337 2.41413 3.33337 3.33329V16.6666C3.33337 17.5858 4.08087 18.3333 5.00004 18.3333H15C15.9192 18.3333 16.6667 17.5858 16.6667 16.6666V7.49996C16.6667 7.48246 16.6575 7.46663 16.6559 7.44829C16.6517 7.37496 16.6375 7.30329 16.6142 7.23329ZM13.8217 6.66663H11.6667V4.51163L13.8217 6.66663ZM5.00004 16.6666V3.33329H10V7.49996C10 7.96079 10.3725 8.33329 10.8334 8.33329H15L15.0017 16.6666H5.00004Z"
        fill={color}
      />
    </svg>
  )
}
